module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="photo_item_image" style="background-image:url(' +
((__t = ( photo_url )) == null ? '' : __t) +
');"></div>\n<div class="album_title">' +
((__t = ( name )) == null ? '' : __t) +
'</div>';

}
return __p
}